import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initSentry, Sentry } from "utils/sentry.init";

import "i18n/config";

import "simplebar-react/dist/simplebar.min.css";

import "styles/index.css";
import { CallProvider } from "contexts/CallContext";

// Initialize Sentry FIRST - before any other code runs
initSentry();

// Global error logging to ensure visibility of uncaught errors
window.addEventListener("error", (event) => {
  console.error("Global error:", event?.error || event?.message || event);
  // Capture uncaught errors in Sentry
  if (event?.error) {
    Sentry.captureException(event.error);
  }
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event?.reason || event);
  // Capture unhandled promise rejections in Sentry
  if (event?.reason) {
    Sentry.captureException(event.reason);
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(

  <CallProvider>
    <App />
  </CallProvider>

);
